function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-b2131290\",\"scoped\":true,\"hasInlineConfig\":true}!sass-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SignUpFormBankId.vue")
}
var normalizeComponent = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?cacheDirectory!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SignUpFormBankId.vue"
import __vue_script__ from "!!babel-loader?cacheDirectory!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SignUpFormBankId.vue"
/* template */
import __vue_template__ from "!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b2131290\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SignUpFormBankId.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2131290"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/login/SignUpFormBankId.vue
// module id = DEe4
// module chunks = 0 1